import {DatePickerRange} from 'components/DatePickerRange';
import {FilterDateRange} from 'new-models';
import React, {FC} from 'react';

export const FilterDatePickerRange: FC<FilterDateRange> = ({minRange, maxRange}) => {
    return <DatePickerRange from={minRange} to={maxRange} />;
};
